var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"headers":_vm.headers,"fixed-header":"","height":"calc(100vh - 270px)","items":_vm.items,"items-per-page":10,"search":_vm.search,"loading":_vm.loading,"loading-text":'Chargement en cours...',"hide-default-footer":"","item-key":"_id","disable-pagination":"","sort-by":"partNumberName"}})
}
var staticRenderFns = []

export { render, staticRenderFns }